import { get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
   id: string;
   name: string;
}

export interface ApiResultTemplateListModel {
    templateList: ApiResultModel[];
}

const url = "/api/v2/PIMExport/GetCustomerTemplate";

export async function getPIMTemplateList(parameter: any) {
    const response = await get<ApiResultTemplateListModel>(url);
    return response;
}
